import React from 'react'
import { observer } from 'mobx-react'
import { Address } from '../commonQuestions/Address'
import { Spacer } from '../../../../../ui/atoms'
import ApplicationStore from '../../ApplicationStore'

export default {
  title: () => {
    return ApplicationStore.isOwner || ApplicationStore.isAuthorised
      ? 'Owner.HomeAddress'
      : 'Owner.AuthorizedHomeAddress'
  },
  component: observer((props) => {
    return (
      <>
        {!props.review && <Spacer height={14} />}
        <Address {...props} testID="user_address" />
      </>
    )
  }),
}
